import { render } from "./gdpr-consent.vue?vue&type=template&id=1b6979bc&ts=true"
import script from "./gdpr-consent.vue?vue&type=script&lang=ts"
export * from "./gdpr-consent.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__